import { createElement as t, Fragment as n, Component as r } from "react";
var o = null,
  e = 0,
  u = function u(t, n) {
    return Math.floor(Math.random() * (n - t + 1)) + t;
  },
  i = function i(t) {
    return function (n) {
      for (var r = "", o = 0; o < n; o++) r += t.charAt(u(0, t.length - 1));
      return r;
    };
  },
  p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
  a = i(p),
  c = i(p + "0123456789"),
  l = function l(t) {
    for (var n = new Array(t), r = 0; r < n.length; r++) n[r] = a(5);
    return n;
  },
  f = l(5),
  h = l(5),
  s = function s(t) {
    return t[Math.floor(Math.random() * t.length)];
  },
  d = function d(t, n) {
    return t.map(function (t) {
      return "." + t + " {\n      " + n + "\n      }";
    });
  };
export default (function (r) {
  function i() {
    r.apply(this, arguments);
  }
  return r && (i.__proto__ = r), (i.prototype = Object.create(r && r.prototype)).constructor = i, i.prototype.componentDidMount = function () {
    if (!o) {
      o = document.createElement("style"), document.head.appendChild(o);
      var t = d(f, "display: none;").concat(d(h, "display: inline-block;")).join("\n");
      o.innerHTML = t;
    }
    e++;
  }, i.prototype.componentWillUnmount = function () {
    if (--e <= 0) {
      if (e = 0, o) {
        var t = o.parentNode;
        t && t.removeChild(o);
      }
      o = null;
    }
  }, i.prototype.shouldComponentUpdate = function (t) {
    return t.text !== this.props.text;
  }, i.prototype.render = function () {
    var r = this.props.text;
    void 0 === r && (r = "");
    for (var o = [], e = function e() {
        return "key-" + o.length;
      }, i = function i(n, r) {
        return t("span", {
          key: e(),
          className: r
        }, n);
      }, p = function p() {
        return t("span", {
          key: e()
        }, " ");
      }, a = 0; a < r.length; a++) {
      for (var l = u(1, 2), d = r.slice(a, a + l), m = u(1, 2), y = 0; y < m; y++) {
        var v = c(2),
          M = s(f);
        o.push(i(v, M));
      }
      d.startsWith(" ") && o.push(p());
      var g = s(h);
      o.push(i(d.trim(), g)), a += l - 1, d.endsWith(" ") && o.push(p());
    }
    return t(n, null, o);
  }, i;
})(r);